<template>
  <div>
    <el-card>
      <el-select
        class="m-w"
        v-model="StatusListValue"
        placeholder="请选择审核状态"
      >
        <el-option
          v-for="item in StatusList"
          :key="item.Id"
          :label="item.Name"
          :value="item.Id"
        >
        </el-option>
      </el-select>
      <el-input
        style="width: 150px"
        class="m-w"
        placeholder="请输入岗位名称"
        v-model="PostName"
      ></el-input>
      <el-button type="primary" icon="el-icon-plus" @click="onClickAdd"
        >新建</el-button
      >
      <el-button type="primary" @click="GetEP_PostByPage">查询</el-button>

      <el-button @click="clecrData">重置</el-button>
    </el-card>
    <el-card style="margin-top: 20px">
      <div class="tui-card" v-show="isChange.length != 0">
        <div class="flex-items">
          <i class="el-icon-warning"></i>
          <div class="title">
            已选择 <span>{{ isChange.length }}</span> 项
          </div>
        </div>
        <div class="clear">清空</div>
      </div>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column label="序号" width="60" align="center">
          <template slot-scope="scope">
            {{ scope.$index + (PageIndex - 1) * PageSize + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="MaskName" label="企业社区名称" align="center">
        </el-table-column>
        <el-table-column prop="PostName" label="岗位名称" align="center">
        </el-table-column>
        <el-table-column
          prop="PostEnumTypeName"
          label="岗位类型"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="Phone" label="邮箱" align="center">
        </el-table-column>
        <el-table-column prop="ManageName" label="负责人名称" align="center">
        </el-table-column>
        <el-table-column prop="StatusName" label="状态" align="center">
        </el-table-column>
        <el-table-column label="启用禁用" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.IsOpen"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="OC_EP_PostInfo($event, scope.row)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <!-- <el-table-column label="介绍" align="center">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.Detail"
              placement="top"
              popper-class="tool-tip"
            >
              <div class="tui-detail">{{ scope.row.Detail }}</div>
            </el-tooltip>
          </template>
        </el-table-column> -->
        <el-table-column label="备注" align="center">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.Remark"
              placement="top"
              popper-class="tool-tip"
            >
              <div class="tui-detail">{{ scope.row.Remark }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="onClickEdit(scope.row)"
              >重新提交</el-button
            >
            <el-button
              type="text"
              style="color: red"
              @click="onClickDelete(scope.row.Id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="PageIndex"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: center; padding: 20px 0 0 0"
      >
      </el-pagination>
    </el-card>
    <el-dialog
      :title="Title"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
          label-position="top"
        >
          <el-form-item label="岗位名称" prop="postName">
            <el-input
              v-model="ruleForm.postName"
              placeholder="请输入岗位名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="负责人名称" prop="manageName">
            <el-input
              v-model="ruleForm.manageName"
              placeholder="请输入负责人名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="介绍" prop="detail">
            <quill-editor
              v-model="ruleForm.detail"
              ref="myQuillEditor"
              class="editer"
              :options="editorOption"
            ></quill-editor>
            <el-upload
              class="avatar-uploader1"
              :file-list="[]"
              :action="uploadUrl"
              :shrow-file-list="false"
              :on-success="uploadSuccess"
            />
          </el-form-item>
          <el-form-item label="邮箱" prop="phone">
            <el-input
              v-model="ruleForm.phone"
              placeholder="请输入邮箱"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 8 }"
              maxlength="200"
              show-word-limit
              v-model="ruleForm.remark"
              placeholder="请输入备注"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          :loading="loading"
          type="primary"
          @click="
            Title == '新增' ? onSubmitAdd('ruleForm') : onSubmitAdd('ruleForm')
          "
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetEP_PostByPage,
  GetCheckStatusSelectInfo,
  GetEP_MaskDetail,
  DeleteEP_PostInfo,
  AddEP_PostInfo,
  OC_EP_PostInfo,
} from "../../api/api";
import { quillEditor } from "vue-quill-editor"; //调用编辑器
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  ["blockquote", "code-block"],
  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }], // superscript/subscript
  [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
  [{ align: [] }],
  ["link", "image"],
  ["clean"], // remove formatting button
];

export default {
  components: { quillEditor },
  data() {
    return {
      StatusList: [],
      StatusListValue: "",
      tableData: [],
      isChange: [],
      PageSize: 10,
      PageIndex: 1,
      total: 0,
      PostName: "",
      userInfo: {},
      MaskId: 0,
      Title: "",
      dialogVisible: false,
      ruleForm: {
        id: 0,
        eP_MaskId: "",
        postName: "",
        postEnumType: "0",
        manageName: "",
        detail: "",
        phone: "",
        remark: "",
      },
      rules: {
        postName: [
          { required: true, message: "请输入岗位名称", trigger: "blur" },
        ],
        eP_MaskId: [
          { required: true, message: "请选择企业", trigger: "change" },
        ],
        manageName: [
          { required: true, message: "请输入负责人名称", trigger: "blur" },
        ],
        detail: [{ required: true, message: "请输入介绍", trigger: "blur" }],
        phone: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
        remark: [{ required: true, message: "请输入备注", trigger: "blur" }],
      },
      loading: false,
      EnterpriseListCopy: [],
      uploadUrl: "/api/Img/UploadImg",
      // 富文本编辑器配置
      editorOption: {
        placeholder: "请输入内容",
        theme: "snow", // or 'bubble'
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: function (value) {
                if (value) {
                  // 触发input框选择图片文件
                  document.querySelector(".avatar-uploader1 input").click();
                } else {
                  this.quill.format("image", false);
                }
              },
            },
          },
        },
      },
    };
  },
  async created() {
    this.userInfo = JSON.parse(
      window.localStorage.user ? window.localStorage.user : null
    );
    await this.GetCheckStatusSelectInfo();
    await this.GetEP_MaskDetail();
    await this.GetEP_PostByPage();
  },
  methods: {
    uploadSuccess(res, file) {
      // res为图片服务器返回的数据
      // 获取富文本组件实例
      let quill = this.$refs.myQuillEditor.quill;
      console.log(res, "res");
      // 如果上传成功
      if (res.success) {
        // 获取光标所在位置
        let length = quill.getSelection().index;
        // 插入图片  res.info为服务器返回的图片地址
        quill.insertEmbed(length, "image", res.response);
        // 调整光标到最后
        quill.setSelection(length + 1);
        this.$forceUpdate();
      } else {
        this.$message.error("图片插入失败");
      }
      // loading动画消失
      this.quillUpdateImg = false;
    },
    async OC_EP_PostInfo(e, item) {
      let res = await OC_EP_PostInfo({
        Id: item.Id,
        IsOpen: item.IsOpen ? 1 : 0,
      });
      this.GetEP_PostByPage();
    },
    clecrData() {
      this.ruleForm = {
        id: 0,
        eP_MaskId: "",
        postName: "",
        postEnumType: "0",
        manageName: "",
        detail: "",
        phone: "",
        remark: "",
      };
      this.PostName = "";
      this.EnterpriseListValue = "";
      this.StatusListValue = 0;
      this.GetEP_PostByPage();
    },
    onSubmitAdd(formName) {
      this.loading = true;
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.ruleForm.eP_MaskId = this.MaskId;
          let res = await AddEP_PostInfo(this.ruleForm);
          if (res.data.success) {
            this.$message({
              type: "success",
              message: "成功",
            });
            this.dialogVisible = false;
            this.loading = false;
            this.$refs[formName].clearValidate();
            this.clecrData();
          } else {
            this.loading = false;

            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    onClickAdd() {
      this.Title = "新增";
      this.dialogVisible = true;
    },
    onClickDelete(Id) {
      this.$confirm("此操作将删除该岗位, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let res = await DeleteEP_PostInfo({ id: Id });
        if (res.data.success) {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.GetEP_PostByPage();
        } else {
          this.$message({
            type: "error",
            message: "删除失败!",
          });
        }
      });
    },
    handleClose() {
      this.clecrData();
      this.dialogVisible = false;
    },
    onClickEdit(item) {
      this.Title = "编辑";
      this.ruleForm = {
        id: item.Id,
        postName: item.PostName,
        postEnumType: "0",
        manageName: item.ManageName,
        detail: item.Detail,
        phone: item.Phone,
        remark: item.Remark,
      };
      this.dialogVisible = true;
    },
    async GetEP_MaskDetail() {
      let res = await GetEP_MaskDetail({
        SysUserId: this.userInfo.uID,
      });
      if (res.data.success) {
        this.MaskId = res.data.response.Id;
      }
    },
    async GetEP_PostByPage() {
      let res = await GetEP_PostByPage({
        PostName: this.PostName,
        MaskId: this.MaskId,
        Status: this.StatusListValue,
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
        Name: "",
      });
      if (res.data.success) {
        this.tableData = res.data.response.data;
        this.total = res.data.response.dataCount;
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
    async GetCheckStatusSelectInfo() {
      let res = await GetCheckStatusSelectInfo();
      if (res.data.success) {
        this.StatusList = res.data.response;
        this.StatusListValue = res.data.response[0].Id;
      }
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.GetEP_PostByPage();
    },
    handleSizeChange(val) {
      this.PageSize = val;
      this.GetEP_PostByPage();
    },
  },
};
</script>
<style lang="less" scoped>
.m-w {
  margin-right: 10px;
}
.tui-detail {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/deep/.el-tooltip__popper {
  max-width: 400px;
}
.tui-card {
  width: 100%;
  height: 40px;
  background-color: rgba(230, 247, 255, 1);
  color: rgba(16, 16, 16, 1);
  border: 1px solid rgba(186, 231, 255, 1);
  margin-bottom: 10px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
  i {
    color: #1890ff;
  }
  .clear {
    color: #1890ff;
  }
  .title {
    padding-left: 10px;
    color: #101010;
    font-size: 14px;
    font-weight: 600;
    span {
      color: #1890ff;
      padding: 0 5px;
    }
  }
}
</style>